import axios from 'axios';

const request = function (servicekey, jsonobjparam, method) {
    let token = Storage.Base.getInstance().get('_loginTk');
    if (!token) {
        token = "";
    }
    return new Promise((resolve, reject) => {
        axios({
            method,
            url: servicekey,
            data: JSON.stringify(jsonobjparam),
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
                'token': token
            },
            timeout: 50000
        }).then(response => {
            console.log(response)
            if (response.status === 200) {
                if (response.data) {
                    resolve(response.data)
                }
            }
        }, err => {
            console.log("error:", err)
            if (err.Cancel) {
                console.log(err)
            } else {
                reject(err)
            }
        }).catch(err => {
            console.log("*****", err)
            reject(err)
        })
    })
};

const post = (servicekey, params) => {
    return request(servicekey, params, 'post')
};

const get = (servicekey, params) => {
    return request(servicekey, params, 'get')
};

export {post, get}

  